import React from 'react';
export function SocialProofSection() {
  return <section className="w-full py-20 md:py-24 relative font-heading overflow-hidden" style={{
    backgroundColor: '#09090B'
  }} data-id="element-743">
      {/* Abstract background elements */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-cyan-500/[0.03] rounded-full blur-[100px] pointer-events-none" data-id="element-744" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-745">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-8" data-id="element-746">
          Déployé sur de vrais événements
        </h2>

        <p className="text-lg md:text-xl text-white/60 leading-relaxed mb-16 max-w-3xl mx-auto" data-id="element-747">
          MeetOS n'est pas un prototype. Il tourne sur des événements réels,
          avec de vrais participants, de vraies données, de vrais retours — et
          chaque événement améliore la prochaine version.
        </p>

        <div className="bg-white/[0.03] border border-white/[0.08] rounded-2xl p-8 md:p-12 relative overflow-hidden" data-id="element-748">
          {/* Subtle grid pattern */}
          <div className="absolute inset-0 opacity-20" style={{
          backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)',
          backgroundSize: '24px 24px'
        }} data-id="element-749" />

          <div className="relative z-10" data-id="element-750">
            <div className="text-5xl md:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500 mb-6" data-id="element-751">
              &gt; 60%
            </div>
            <p className="text-xl md:text-2xl text-white/80 font-medium" data-id="element-752">
              Taux de réunions confirmées sur les événements utilisant le module
              networking
            </p>
          </div>
        </div>
      </div>
    </section>;
}